import lodash from 'lodash';
import {queryGraphQL} from 'common/util/query';
import {nodeWithArgs, toQuery, node} from 'common/util/queryHelper';
import {addApplicationMessage} from 'common/actions/applicationMessagesActions';

export const STUDIES_WRITE = 'STUDIES_WRITE';
export const STUDIES_UNLOAD = 'STUDIES_UNLOAD';
export const STUDY_STAGES_WRITE = 'STUDY_STAGES_WRITE';

const STUDY_REQUEST_LIMIT = 10;

export function loadStudiesOverview(offset, limit = STUDY_REQUEST_LIMIT) {
    return async (dispatch) => {
        const queryName = 'studies';
        const args = {limit, offset};
        const studyQuery = nodeWithArgs(queryName, args, [
            'id',
            'institutionId',
            'name',
            'binderId',
            'studyTypeId',
            'createdAt',
            'updatedAt',
            'pendingTasksCount',
            'unfiledDocumentsCount',
            'userHasAccess',
            node('currentStage', [
                'name'
            ]),
            'binderPermissions'
        ]);

        dispatch(queryStudies([], true));

        const response = await queryGraphQL(toQuery(studyQuery));

        if (response.errors) {
            dispatch(addApplicationMessage('error', 'Failed to load studies. Please try again'));
        } else {
            dispatch(queryStudies(response.data[queryName], false));
        }
    };
}

export function loadStudyStages() {
    return async (dispatch, getState) => {
        const storeState = getState();
        const institutionId = lodash.get(storeState, 'me.institution.id');
        const studyStagesQuery = nodeWithArgs('getStudyStages', {
            institutionId
        }, [
            'id',
            'name',
            'description',
            'institutionId',
            'createdAt',
            'updatedAt',
        ]);

        const response = await queryGraphQL(toQuery(studyStagesQuery));

        if (response.errors) {
            return dispatch(addApplicationMessage('error', 'Failed to load study stages. Please try again'));
        } else {
            return dispatch({
                type: STUDY_STAGES_WRITE,
                payload: response.data.getStudyStages
            });
        }
    };
}

export function unloadStudiesOverview() {
    return dispatch => {
        return dispatch(unloadStudiesOverviewAction());
    };
}

function queryStudies(studies, isLoading) {
    return {
        type: STUDIES_WRITE,
        payload: {studies, isLoading}
    };
}

function unloadStudiesOverviewAction() {
    return {
        type: STUDIES_UNLOAD
    };
}
